<template>
  <!-- 앱: 앱 전용 상단 네비게이션 -->
  <div v-if="isApp" class="lg:flex flex-1">
    <appNavigator :page="pageName" />
    <EduRegisterPage />
  </div>

  <!-- 웹: 공용 네비게이션 -->
  <template v-else>
    <Nav />
    <toTopComponent />
    <main class="register-main">
      <EduRegisterPage />
    </main>
    <Footer />
  </template>
</template>

<script>
import Nav from "@/components/new/TNavComponent.vue";
import toTopComponent from "@/components/toTopComponent.vue";
import Footer from "@/components/new/Footer.vue";
import EduRegisterPage from "@/pages/EduRegisterPage.vue";
import AppNavigator from "@/components/appNavigator.vue";

export default {
  name: "EduRegisterView",
  components: { AppNavigator, EduRegisterPage, Nav, toTopComponent, Footer },
  data() {
    return {
      pageName: this.$route.name,
    };
  },
  computed: {
    isApp() {
      return (
        this.pageName === "eduRegisterApp" ||
        this.pageName === "eduRegister2App"
      );
    },
  },
};
</script>

<style scoped>
/* TNavComponent는 문서 흐름 안의 sticky 네비게이션이라 상단 여백 보정이 필요 없다 */
.register-main {
  min-height: calc(100vh - var(--nav-height, 80px));
}
</style>
